import { render, staticRenderFns } from "./GrupoOpcion.vue?vue&type=template&id=09516980&"
import script from "./GrupoOpcion.vue?vue&type=script&lang=js&"
export * from "./GrupoOpcion.vue?vue&type=script&lang=js&"
import style0 from "./GrupoOpcion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports